import React, { useCallback, useMemo } from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import {
  FilterElement
} from "../../../components/shared/filters/FilterElement";
import {
  DEFAULT_RADIO_FILTER_ALL_VALUE,
  FILTER_TYPES,
} from "../../../config/constants";

const FiltersTableList = (props) => {
  const {
    filters = [],
    selectedDateFilters,
    onRemoveFilter,
    onRemoveAllFilters,
    removeDateFilter,
    filtersApplied,
  } = props;

  const renderFilterItem = useCallback((filter) => {
    if (filter?.values?.[0] === DEFAULT_RADIO_FILTER_ALL_VALUE) {
      return null;
    }

    return filter?.values.map((value, index) => {
      let el = {};

      el.title = filter?.type === FILTER_TYPES.CHECKBOX ? (
        filter?.list[value]
      ) : (
        <FormattedMessage id={`messages.${filter.values[0]}`} />
      );

      el.label = filter.name;
      el.identifier = value;
      el.filter = filter;

      return (
        <FilterElement key={index} item={el} onRemoveFilter={onRemoveFilter} />
      );
    });
  }, [onRemoveFilter]);

  const renderActiveFilters = useMemo(() => {
    if (!filtersApplied) {
      return null;
    }

    return filters.map((filter, index) => {
      return renderFilterItem(filter, index);
    });
  }, [filters, renderFilterItem, filtersApplied]);

  const renderDateFilters = useMemo(() => {
    if (!selectedDateFilters) {
      return null;
    }

    if (!Object.keys(selectedDateFilters).length) {
      return null;
    }

    return Object.keys(selectedDateFilters).map((key, index) => {
      let el = {};

      el.title = selectedDateFilters[key]?.values;
      el.label = selectedDateFilters[key]?.name;
      el.identifier = index;
      el.filter = selectedDateFilters[key];

      return (
        <FilterElement key={index} item={el}
          onRemoveFilter={() => removeDateFilter(selectedDateFilters[key].entity)} />
      );
    });
  }, [selectedDateFilters, removeDateFilter]);

  if (!filtersApplied && !selectedDateFilters) {
    return null;
  }

  if (!filtersApplied && !Object.keys(selectedDateFilters).length) {
    return null;
  }

  return (
    <Row className="align-items-center pl-3">
      <Col className="ml-3">
        <span>
          <FormattedMessage id="app.active.filters" />
        </span>

        {renderActiveFilters}
        {renderDateFilters}
        <Link
          to="#"
          className="cursor-pointer ml-2 link-icon-color d-inline-flex"
          id={`clear-all`}
          onClick={(e) => {
            e.preventDefault();
            onRemoveAllFilters();
          }}
        >
          <FormattedMessage id="button.clear.all" />
        </Link>
      </Col>
    </Row>
  );
};

export { FiltersTableList };
